import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Layout } from '@web-kc/shared/components';
import { useTranslation } from 'next-i18next';
import { PlanListWrapped } from './PlanList';

export const PagesPublicPlansPlanList = () => {
  const { t } = useTranslation(['common', 'plans']);

  return (
    <Layout
      paths={['/', '/plans']}
      labels={[t('common:breadcrumbs.main'), '']}
      pageTitle={t('plans:purchasePlan')}
    >
      <Typography
        variant="h1"
        fontWeight={700}
        fontSize="36px"
        lineHeight="36px"
      >
        {t('plans:purchasePlan')}
      </Typography>
      <Box
        mt={4}
        sx={{
          borderRadius: '4px',
          boxShadow: '0px 1px 3px 0 rgba(0,0,0,0.3)',
          padding: '20px',
          width: '100%',
          backgroundColor: '#fff',
        }}
      >
        <PlanListWrapped />
      </Box>
    </Layout>
  );
};
